<script>
export default {}
</script>
<template>
  <div class="card">
    <div class="card-body pb-0">
      <div class="text-center mt-3">
        <img
          src="@assets/images/users/avatar-7.jpg"
          alt
          class="avatar-xl rounded-circle"
        />
        <h5 class="mt-2 mb-0">Shreyu N</h5>
        <h6 class="text-muted font-weight-normal mt-2 mb-4">
          User Experience Specialist
        </h6>

        <button type="button" class="btn btn-primary btn-sm mr-1"
          >Follow</button
        >
        <button type="button" class="btn btn-white btn-sm">Message</button>

        <div class="mt-4 pt-3 border-top text-left">
          <p class="text-muted mb-2">
            Hi I'm Shreyu. I am user experience and user interface designer. I
            have been working on UI & UX since last 10 years.
          </p>

          <p class="mb-2">
            <label class="badge badge-soft-success">UI & UX</label>
            <label class="badge badge-soft-success ml-1"
              >Frontend Development</label
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
